<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Tipo Complemento: </span>
      <span class="">{{ tipoComplemento.descricao }}</span>
    </div>
  </ng-template>
    <div class="p-fluid">
      <div class="p-field p-grid">
        <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
        <div class="p-col-12 p-md-10">{{ tipoComplemento.id }}</div>
      </div>
      <div class="p-field p-grid">
        <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Categoria:</label>
        <div class="p-col-12 p-md-10">{{tipoComplemento.categoria  | dominio: 'getCategoriaTipoComplemento'}}</div>
      </div>
      <div class="p-field p-grid">
        <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Descrição:</label>
        <div class="p-col-12 p-md-10">{{tipoComplemento.descricao}}</div>
      </div>
      <div class="p-field p-grid">
        <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Observação:</label>
      <div class="p-col-12 p-md-10">{{tipoComplemento.observacao}}</div>
    </div>
  </div>
  <p-tabView>
    <p-tabPanel header="Movimentos">
        <div class="p-p-3">
          <p-table
            [value]="tipoComplemento.movimentos"
            [totalRecords]="tipoComplemento.movimentos?.length"
            [paginator]="true"
            [showCurrentPageReport]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10,25,50,100]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
            responsive="true"
            sortMode="multiple"
            responsiveLayout="scroll"
            styleClass="p-datatable-striped"
            emptyMessage="Nenhum registro encontrado">
            <ng-template pTemplate="header">
              <tr>
                <th class="p-text-center" style="width: 150px;">Id</th>
                <th style="text-align: center">Nome</th>
                <th style="text-align: center">Descrição</th>
                <th style="text-align: center">Vigência início</th>
                <th style="text-align: center">Vigência fim</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-movimento>
              <tr>
                <td class="p-text-center">{{ movimento.tipoMovimento.id }}</td>
                <td>
                  <a [routerLink]="['/tipoMovimento/visualizar/', movimento.tipoMovimento.id]">{{ movimento.tipoMovimento.nome }}</a>
                </td>
                <td>{{ movimento.tipoMovimento.descricao }}</td>
                <td>{{movimento.vigenciaInicio | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                <td>{{movimento.vigenciaFim | date:'dd/MM/yyyy HH:mm:ss'}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6"> Movimento sem Tipo Complemento.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Itens" [disabled]="isItensTabDisabled()">
      <div class="p-p-3">
        <p-table
          [value]="tipoComplemento.itens"
          [totalRecords]="tipoComplemento.itens?.length"
          [paginator]="true"
          [showCurrentPageReport]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10,25,50,100]"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          responsive="true"
          sortMode="multiple"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped"
          emptyMessage="Nenhum registro encontrado">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-text-center" style="width: 150px;">Id</th>
              <th style="text-align: center">Descrição</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tipoComplementoTabelado>
            <tr>
              <td class="p-text-center">{{ tipoComplementoTabelado.id }}</td>
              <td>{{ tipoComplementoTabelado.descricao }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6"> Movimento sem Tipo Complemento Tabelado.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>
  </p-tabView>
  <ng-template pTemplate="footer">
    <div class="p-col-12">
      <button pButton appBotaoVoltar class="p-button-primary p-lg-12" label="Voltar"></button>
    </div>
  </ng-template>
</p-card>
